import { inject, injectable } from "inversify";
import { ICPLMeetingTypesClient, IntSelectModel, MeetingTypeModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IMeetingTypesService {
  getMeetingTypes(): Promise<MeetingTypeModel[]>;
  createMeetingType(name: string): Promise<void>;
  updateMeetingType(meetingTypeModel: MeetingTypeModel): Promise<void>;
  deleteMeetingType(meetingTypeID: number): Promise<void>;
  getMeetingTypeSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class MeetingTypesService implements IMeetingTypesService {
  @inject(SERVICE_TYPES.CPLMeetingTypesClient) cplMeetingTypesClient!: ICPLMeetingTypesClient;

  async getMeetingTypes(): Promise<MeetingTypeModel[]> {
    return this.cplMeetingTypesClient.getMeetingTypes();
  }

  async createMeetingType(name: string): Promise<void> {
    return this.cplMeetingTypesClient.createMeetingType(name);
  }

  async updateMeetingType(meetingTypeModel: MeetingTypeModel): Promise<void> {
    return this.cplMeetingTypesClient.updateMeetingType(meetingTypeModel);
  }

  async deleteMeetingType(meetingTypeID: number): Promise<void> {
    return this.cplMeetingTypesClient.deleteMeetingType(meetingTypeID);
  }

  async getMeetingTypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplMeetingTypesClient.getMeetingTypeSelectModels();
  }
}
